export enum RouterNameEnum {
    Main = 'Main',
    Home = 'Home',
    Dashboard = 'Dashboard',
    AuthLogin = 'AuthLogin',
    AuthRegister = 'AuthRegister',
    AuthRecover = 'AuthRecover',

    Salons = 'Salons',
    SalonsPage = 'SalonsPage',

    Reports = 'Reports',
    ReportSalesByService = 'ReportSalesByService',
    ReportFinance = 'ReportFinance',

    Store = 'Store',
    StoreDetail = 'StoreDetail',

    Stores = 'Stores',
    StoresPage = 'StoresPage',

    StoreOperations = 'StoreOperations',
    StoreOperationsPage = 'StoreOperationsPage',

    StoreOperationsReport = 'StoreOperationsReport',
    StoreOperationsSale = 'StoreOperationsSale',
    StoreOperationsWriteOff = 'StoreOperationsWriteOff',
    StoreOperationsArrival = 'StoreOperationsArrival',
    StoreOperationsMove = 'StoreOperationsMove',
    StoreOperationsGet = 'StoreOperationsGet',

    StoresProducts = 'StoresProducts',
    StoresProductsPage = 'StoresProductsPage',
    StoresProductsSelect = 'StoresProductsSelect',

    ListedProducts = 'ListedProducts',
    ListedProductsPage = 'ListedProductsPage',

    StoresSelect = 'StoresSelect',
    StoresSelectPage = 'StoresSelectPage',

    StoresProductsArchived = 'StoresProductsArchived',
    StoresProductsPageArchived = 'StoresProductsPageArchived',

    StoresProductsCreate = 'StoresProductsCreate',
    StoresProductPage = 'StoresProductPage',

    StoresProductsMassEdit = 'StoresProductsMassEdit',
    StoresProductsMassEditPage = 'StoresProductsMassEditPage',

    StoreSettings = 'StoreSettings',

    IndexStore = 'IndexStore',
    CreateStore = 'CreateStore',

    Clients = 'clients',
    ClientsPage = 'clientsPage',
    clientCreate = 'clientCreate',

    Settings = 'Settings',
    SettingsUsers = 'SettingsUsers',
    SettingsUsersPage = 'SettingsUsersPage',
    SettingsRolesAndAccess = 'SettingsRoleAndAccess',

    SettingsFinance = 'SettingsFinance',
    SettingsFinancePayment = 'SettingsFinancePayment',

    SettingsCategories = 'SettingsCategories',
    SettingsCategoriesVisits = 'SettingsCategoriesVisits',
    SettingsCategoriesClients = 'SettingsCategoriesClients',
    SettingsCategoriesSource = 'SettingsCategoriesSource',

    SettingsSite = 'SettingsSite',
    SettingsSiteServices = 'SettingsSiteServices',
    SettingsSiteServicesEdit = 'SettingsSiteServicesEdit',
    SettingsSiteNews = 'SettingsSiteNews',
    SettingsSiteVacancies = 'SettingsSiteVacancies',


    Loyalty = 'Loyalty',
    //LoyaltyCertPage = 'LoyaltyCertPage',
    SalonDetail = 'SalonDetail',
    SalonCreation = 'SalonCreation',
    SalonDetailCommon = 'SalonDetailCommon',
    SalonDetailFinance = 'SalonDetailFinance',
    SalonDetailReports = 'SalonDetailReports',
    SalonDetailClients = 'SalonDetailClients',
    SalonDetailClientsPage = 'SalonDetailClientsPage',

    SalonDetailWorkers = 'SalonDetailWorkers',
    SalonDetailPhoto = 'SalonDetailPhoto',
    SalonDetailDocs = 'SalonDetailDocs',
    SalonDetailAllow = 'SalonDetailAllow',

    ClientDetail = 'ClientDetail',
    ClientCreation = 'ClientCreation',
    ClientDetailCommon = 'ClientDetailCommon',

    ClientDetailHistory = 'ClientDetailHistory',
    ClientDetailHistoryPage = 'ClientDetailHistoryPage',


    ClientDetailNotes = 'ClientDetailNotes',
    ClientDetailNotesPage = 'ClientDetailNotesPage',


    ClientDetailTasks = 'ClientDetailTasks',
    ClientDetailDocuments = 'ClientDetailDocuments',
    ClientDetailPhoto = 'ClientDetailPhoto',
    ClientDetailContraindications = 'ClientDetailContraindications',
    ClientDetailLoyalty = 'ClientDetailLoyalty',

    ClientAccounts = 'ClientAccounts',
    ClientAccountsPage = 'ClientAccountsPage',
    ClientDetailAccountsPage = 'ClientDetailAccountsPage',

    ClientsAccounts = 'ClientsAccounts',
    ClientsAccountsPage = 'ClientsAccountsPage',

    ClientsAccountsAll = 'ClientsAccountsAll',
    ClientsAccountsAllPage = 'ClientsAccountsAllPage',



    Finance = 'Finance',
    AccountsAndCashboxes = 'AccountsAndCashboxes',
    Counterparties = 'Counterparties',
    CounterpartiesPage = 'CounterpartiesPage',

    PaymentArticles = 'PaymentArticles',
    PaymentArticlesPage = 'PaymentArticlesPage',

    FinanceDocuments = 'FinanceDocuments',

    FinanceOperations = 'FinanceOperations',
    FinanceOperationsPage = 'FinanceOperationsPage',

    Services = 'Services',
    ServicesPage = 'ServicesPage',

    PartnerServices = 'PartnerServices',

    LoyaltyCert = 'LoyaltyCert',
    LoyaltyCertPage = 'LoyaltyCertPage',

    LoyaltyCertType = 'LoyaltyCertType',
    LoyaltyCertTypePage = 'LoyaltyCertTypePage',

    LoyaltyCertTypeAdd = 'LoyaltyCertTypeAdd',
    LoyaltyCertTypeGet = 'LoyaltyCertTypeGet',

    LoyaltySubscriptionIndex = 'LoyaltySubscriptionIndex',
    LoyaltySubscription = 'LoyaltySubscription',
    LoyaltySubscriptionPage = 'LoyaltySubscriptionPage',
    LoyaltySubscriptionCard = "LoyaltySubscriptionCard",

    LoyaltySubscriptionType = 'LoyaltySubscriptionType',
    LoyaltySubscriptionTypePage = 'LoyaltySubscriptionTypePage',

    LoyaltyBonus = 'LoyaltyBonus',
    LoyaltyBonusType = 'LoyaltyBonusType',
    LoyaltyStock = 'LoyaltyStock',
    ServicesCreation = 'ServicesCreation',
    ServiceUpdate = 'ServiceUpdate',
    PartnerServiceUpdate = 'PartnerServiceUpdate',
    ServicesCreationCosmetologists = 'ServicesCreationCosmetologists',
    ServicesCreationConsumables = 'ServicesCreationConsumables',
    ServicesCreationDocuments = 'ServicesCreationDocuments',
    ServicesCreationAnamnez = 'ServicesCreationAnamnez',
    ServicesCreationAlgoritm = 'ServicesCreationAlgoritm',
    ServicesCategory = 'ServicesCategory',
    ServicesCategoryCreation = 'ServicesCategoryCreation',
    ServiceDetail = 'ServiceDetail',
    ServicePartnerDetail = 'ServicePartnerDetail',
    ServiceDetailWorkers = 'ServiceDetailWorkers',
    ServiceDetailProducts = 'ServiceDetailProducts',
    ServiceDetailDocuments = 'ServiceDetailDocuments',
    ServiceDetailAnamnez = 'ServiceDetailAnamnez',
    Visits = 'Visits',
    VisitsDetail = 'VisitDetail',

    VisitsNew = 'VisitsNew',
    VisitsNewAdd = 'VisitsNewAdd',
    VisitsNewDate = 'VisitsNewDate',
    VisitsNewCreate = 'VisitsNewCreate',
    VisitsNewDetail = 'VisitsNewDetail',
    VisitsNewStatus = 'VisitsNewStatus',
    VisitsNewStatusFm = 'VisitsNewStatusFm',
    VisitsNewStatusAddCertificate = 'VisitsNewStatusAddCertificate',
    VisitsNewPayReport = 'VisitsNewPayReport',

    VisitsNewDebt = 'VisitsNewDebt',
    VisitsNewService = 'VisitsNewService',
    VisitsNewPay = 'VisitsNewPay',
    VisitsNewHistory = 'VisitsNewHistory',
    VisitsNewProducts = 'VisitsNewProducts',



    VisitsNewRecord = 'VisitsNewRecord',

    VisitsNewAddwithParams = 'VisitsNewAddwithParams',

    PartnerServicesPage = "PartnerServicesPage",

    WorkerSchedule = 'WorkerSchedule',
    SalonDetailFinancePage = "SalonDetailFinancePage",
    SalaryСalculations = "SalaryСalculations",
    MutualSettlements = "MutualSettlements",
    SettlementPerDay = "SettlementPerDay",
    SettlementPerPeriod = "SettlementPerPeriod",
    BonusesAndPenalties = "BonusesAndPenalties",
    cosmetologCard = "cosmetologCard",
    CalculationCriteria = "CalculationCriteria",
    CalculationSchemes = "CalculationSchemes",
    CreateNewCriteria = "CreateNewCriteria",
    CreateNewRule = "CreateNewRule",
    WageCalculationScheme = "WageCalculationScheme",
    NewScheme = "NewScheme",
    ClientDetailTasksPage = "ClientDetailTasksPage",
    ClientDetailDocumentsPage = "ClientDetailDocumentsPage",
    ClientDetailPhotoPage = "ClientDetailPhotoPage",
    ClientDetailContraindicationsPage = "ClientDetailContraindicationsPage",
    ClientDetailLoyaltyPage = "ClientDetailLoyaltyPage",
    ClientDetailLoyaltyIndex = "ClientDetailLoyaltyIndex",
    clientsDetailLoyaltySubscriptions = 'clientsDetailLoyaltySubscriptions',
    clientsDetailLoyaltyCertificates = 'clientsDetailLoyaltyCertificates',
    SalesTarget = "SalesTarget",
    BeEmployee = "BeEmployee",
    BeEmployeeDynamics = "BeEmployeeDynamics",
    SalesByService = "SalesByService",
    SalesByClients = "SalesByClients",
    SalesByServicePage = "SalesByServicePage"
}
